import styled from 'styled-components';

import {
  colorAccent50,
  colorBlack200,
  colorBlack900,
  colorGrey50,
  colorGrey75,
  colorWhite,
  mediaQueryMobileSmallMax,
} from 'styles';

const getArchiveDayRowBackground = ({ $isHighlighted, $isEven }) => {
  if ($isHighlighted) {
    return colorAccent50;
  }

  return $isEven ? colorGrey50 : colorWhite;
};

export const BodyRow = styled.tr`
  height: 48px;
  background: ${getArchiveDayRowBackground};
  border-bottom: 1px solid ${colorGrey75};

  & > td {
    background: ${getArchiveDayRowBackground};
  }

  &:last-child {
    border-bottom: 0;
  }
`;

export const DateCell = styled.td`
  padding: 0 16px;
  font-size: 14px;
  line-height: 28px;
  color: ${colorBlack200};
  white-space: nowrap;
  vertical-align: middle;

  @media ${mediaQueryMobileSmallMax} {
    padding: 0 8px;
    font-size: 14px;
  }
`;

export const RateCell = styled.td`
  padding: 0 16px;
  text-align: left;
  vertical-align: middle;

  @media ${mediaQueryMobileSmallMax} {
    padding: 0 8px;
  }
`;

export const RateValue = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorBlack900};
  font-variant-numeric: lining-nums proportional-nums;

  @media ${mediaQueryMobileSmallMax} {
    font-size: 16px;
    line-height: 20px;
  }
`;
